(function () {
    'use strict';

    // Bootstrap breakpoint for desktop (lg: 992px)
    const DESKTOP_BREAKPOINT = 992;

    function isDesktop() {
        return window.innerWidth >= DESKTOP_BREAKPOINT;
    }

    function initDropdownHover() {
        // Helper function to attach hover/focus events to dropdown items
        function attachDropdownEvents(item, toggle, menu) {
            if (!toggle || !menu) return;

            let hideTimeout;
            let showTimeout;
            let lastShownTime = 0;
            const MIN_OPEN_DURATION = 200; // Prevent immediate closing
            const HOVER_OPEN_DELAY = 150; // Wait before opening on hover

            // Mouse enter - show dropdown on desktop
            item.addEventListener('mouseenter', function () {
                if (isDesktop()) {
                    clearTimeout(hideTimeout);
                    clearTimeout(showTimeout);
                    showTimeout = setTimeout(function () {
                        const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(toggle);
                        if (!toggle.classList.contains('show')) {
                            const originalFocus = toggle.focus;
                            toggle.focus = () => { }; // Bootstrap wants to apply focus-visible. We only want focus-visible styles during keyboard nav, so we nix the button's focus function while showing
                            bsDropdown.show();
                            toggle.focus = originalFocus; // Restore the original focus function
                            lastShownTime = Date.now();
                        }
                    }, HOVER_OPEN_DELAY);
                }
            });

            // Mouse leave - hide dropdown on desktop with delay
            item.addEventListener('mouseleave', function () {
                if (isDesktop()) {
                    clearTimeout(showTimeout);

                    // Prevent immediate closing after opening (fixes touch device issue)
                    const timeSinceOpened = Date.now() - lastShownTime;
                    const delay = timeSinceOpened < MIN_OPEN_DURATION ? MIN_OPEN_DURATION - timeSinceOpened + 100 : 100;

                    hideTimeout = setTimeout(function () {
                        const bsDropdown = bootstrap.Dropdown.getInstance(toggle);
                        if (bsDropdown) {
                            bsDropdown.hide();
                        }
                    }, delay);
                }
            });

            // Focus in - show dropdown on desktop
            item.addEventListener('focusin', function () {
                if (isDesktop()) {
                    clearTimeout(hideTimeout);
                    const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(toggle);
                    if (!toggle.classList.contains('show')) {
                        bsDropdown.show();
                        lastShownTime = Date.now();
                    }
                }
            });

            // Focus out - hide dropdown on desktop with delay
            item.addEventListener('focusout', function (e) {
                if (isDesktop()) {
                    // Check if focus is moving to an element outside this dropdown
                    if (!item.contains(e.relatedTarget)) {
                        const timeSinceOpened = Date.now() - lastShownTime;
                        const delay = timeSinceOpened < MIN_OPEN_DURATION ? MIN_OPEN_DURATION - timeSinceOpened + 100 : 100;

                        hideTimeout = setTimeout(function () {
                            const bsDropdown = bootstrap.Dropdown.getInstance(toggle);
                            if (bsDropdown) {
                                bsDropdown.hide();
                            }
                        }, delay);
                    }
                }
            });

            // Keep dropdown open when hovering over the menu
            menu.addEventListener('mouseenter', function () {
                if (isDesktop()) {
                    clearTimeout(hideTimeout);
                }
            });

            // Hide when leaving the menu
            menu.addEventListener('mouseleave', function () {
                if (isDesktop()) {
                    const timeSinceOpened = Date.now() - lastShownTime;
                    const delay = timeSinceOpened < MIN_OPEN_DURATION ? MIN_OPEN_DURATION - timeSinceOpened + 100 : 100;

                    hideTimeout = setTimeout(function () {
                        const bsDropdown = bootstrap.Dropdown.getInstance(toggle);
                        if (bsDropdown) {
                            bsDropdown.hide();
                        }
                    }, delay);
                }
            });

            // Allow clicks on all devices - let Bootstrap handle toggling naturally
            // Hover is just an enhancement, not a replacement for click behavior
            toggle.addEventListener('click', function (e) {
                if (isDesktop()) {
                    // Clear any pending hide timeout to let the click toggle naturally
                    clearTimeout(hideTimeout);
                    lastShownTime = Date.now();
                }
            });
        }

        // Target main navigation dropdowns only
        const navItems = document.querySelectorAll('.navbar .nav-item.has-submenu');
        navItems.forEach(function (navItem) {
            const toggle = navItem.querySelector('[data-bs-toggle="dropdown"]');
            const menu = navItem.querySelector('.dropdown-menu');
            attachDropdownEvents(navItem, toggle, menu);
        });

        //close supermenus when interacting outside of them
        const superMenus = document.querySelectorAll('.navbar .supernav-menu');

        function hasOpenSuperMenu() {
            return Array.from(superMenus).some(function (menu) {
                return menu.classList.contains('show');
            });
        }

        function closeCurrentSuperMenus() {
            const showingDropdowns = document.querySelectorAll('.navbar [data-bs-toggle="dropdown"].show');
            Array.from(showingDropdowns).forEach(function (button) {
                button.click();
            });
        }

        function isInsideSuperNav(element) {
            if (!element) return false;

            return element.closest('.supernav-menu') !== null ||
                element.closest('.nav-item.supernav-item') !== null;
        }

        // click outside
        document.addEventListener('click', function (event) {
            if (!hasOpenSuperMenu()) return;
            if (!isInsideSuperNav(event.target)) {
                closeCurrentSuperMenus();
            }
        });

        // Keyboard focus outside
        document.addEventListener('focusin', function (event) {
            if (!hasOpenSuperMenu()) return;
            if (!isInsideSuperNav(event.target)) {
                closeCurrentSuperMenus();
            }
        }, true);
    }

    function initDropdownKeyboardNav() {
        const mmContainer = $(".navbar-collapse-inner ul.navbar-nav");
        const mmListItems = mmContainer.children("li");
        const mmTriggers = mmListItems.children("a, button");
        const mmLinkItems = mmListItems.children(".dropdown-menu").find("a, button");

        mmTriggers.on("keydown", function (e) {
            var submenu = $(this).parent(".nav-item").find(".submenu-container");
            var activeLinks = submenu.find("a, button");

            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                case "Enter":
                    e.preventDefault();
                    activeLinks.eq(0).focus();
                    break;
                case "Tab": //give focus to first focusable element on the page
                    if (!e.shiftKey) {
                        e.preventDefault();
                        $("#page-content").find('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])').eq(0).focus();
                    }
                    break;
                case "Escape":
                    e.preventDefault();
                    break;
            }
        });

        mmLinkItems.on("keydown", function (e) {
            var listItem = $(this).parents(".nav-item");
            var submenu = $(this).parents(".submenu-container");
            var activeLinks = submenu.find("a, button");
            var currentIndex = activeLinks.index($(this));

            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    if (currentIndex == activeLinks.length - 1) {
                        activeLinks.eq(0).focus();
                    } else {
                        activeLinks.eq(currentIndex + 1).focus();
                    }
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    if (currentIndex == 0) {
                        activeLinks.eq(activeLinks.length - 1).focus();
                    } else {
                        activeLinks.eq(currentIndex - 1).focus();
                    }
                    break;
                case "ArrowDown": //up & down event are prevented by bootstrap
                case "ArrowUp":
                    e.preventDefault();
                    break;
                case "Escape":
                    e.preventDefault();
                    listItem.children("a, button").focus();
                    break;
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDropdownHover);
        document.addEventListener('DOMContentLoaded', initDropdownKeyboardNav);
    } else {
        initDropdownHover();
        initDropdownKeyboardNav();
    }

    // Close all dropdowns on window resize when switching between breakpoints
    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            const allToggles = document.querySelectorAll('[data-bs-toggle="dropdown"], .dropdown-toggle');
            allToggles.forEach(function (toggle) {
                const bsDropdown = bootstrap.Dropdown.getInstance(toggle);
                if (bsDropdown) {
                    bsDropdown.hide();
                }
            });
        }, 250);
    });
})();
